module.exports = __webpack_public_path__ + "static/media/passo5.5a356cb8.jpg";